import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchProviderList } from "../services/gameService";

// Map flat provider list into old grouped structure and keep compatibility fields
const normalizeProviders = (raw) => {
  const groups = { slots: [], liveCasino: [], sportbook: [], cardGames: [] };
  const list = Array.isArray(raw) ? raw : [];
  const mapTokenToGroup = (token) => {
    switch (token) {
      case "slot":
        return "slots";
      case "casino":
        return "liveCasino";
      case "sport":
        return "sportbook";
      case "fishing":
        return "cardGames";
      default:
        return null;
    }
  };

  list.forEach((item) => {
    if (!item) return;
    const base = {
      // new fields
      game: item.game,
      name: item.name,
      logo: item.logo,
      type: item.type,
      status: item.status,
      isOpen: item.isOpen,
      // backward-compatible fields
      productId: item.game,
      productName: item.name,
      image: item.logo, // keep as absolute URL for consumers that use image
    };

    const tokens = String(item.type || "")
      .toLowerCase()
      .split(/\s+/)
      .filter(Boolean);
    tokens.forEach((t) => {
      const group = mapTokenToGroup(t);
      if (group) groups[group].push(base);
    });
  });

  return groups;
};

// Async thunk for fetching game list
export const fetchGames = createAsyncThunk(
  "games/fetchGames",
  async (_, { rejectWithValue }) => {
    try {
      const response = await fetchProviderList();
      const data = response.data;
      return normalizeProviders(data);
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const gameSlice = createSlice({
  name: "games",
  initialState: {
    gameList: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearGames: (state) => {
      state.gameList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchGames.fulfilled, (state, action) => {
        state.loading = false;
        state.gameList = action.payload; // now grouped object with compatibility fields
      })
      .addCase(fetchGames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError, clearGames } = gameSlice.actions;
export default gameSlice.reducer;
